//Automatically generated with RestApiToTS.exe
//svn://server2/innodotnet/trunk/WebCRM/RestApiToTS

import { Config } from "../../core/config/config.js";
import * as utility from "../services.js"
export class Innosoft_InnoBI_Controllers_StatisticTranslationsController extends utility.ApiControllerBase {
    GetTranslations(request: any, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticTranslations/Dummy/GetTranslations', { request: request }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetTranslationsForLanguage(language: any, useCustomTranslations: any, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticTranslations/Dummy/GetTranslationsForLanguage', { language: language, useCustomTranslations: useCustomTranslations }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetTranslationsEditorViewData(success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticTranslations/Dummy/GetTranslationsEditorViewData', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetTranslationsInSelectedLanguages(transReq: Innosoft_InnoBI_Controllers_GetTranslationsRequest, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticTranslations/Dummy/GetTranslationsInSelectedLanguages', null, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { transReq: transReq });
    }
    SaveTranslations(translations: Innosoft_InnoBI_Controllers_StatisticTranslationsController_TranslationKeyValue[], success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticTranslations/Dummy/SaveTranslations', null, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { translations: translations });
    }
    DeleteTranslation(translations: Innosoft_InnoBI_Controllers_StatisticTranslationsController_TranslationKeyValue[], success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticTranslations/Dummy/DeleteTranslation', null, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { translations: translations });
    }
}
export class Innosoft_InnoBI_Controllers_UserAdminController extends utility.ApiControllerBase {
    GetAllStatisticsWithRights(user: string, showInternal: boolean, success?: (result: { Data: Innosoft_InnoBI_Controllers_StatisticUiCategories[] }) => void, failure?: (result: any) => void) {
        utility.httpService.get(Config.baseUrl + 'UserAdmin/GetAllStatisticsWithRights', { user: user, showInternal: showInternal }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, true);
    }
    GetUsersAndRoles(success?: (result: { Data: Innosoft_WebCRM_Statistics_Model_User[] }) => void, failure?: (result: any) => void) {
        utility.httpService.get(Config.baseUrl + 'UserAdmin/GetUsersAndRoles', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, true);
    }
    GetAllUSersAndStatisticsCurrentUser(showInternal: boolean, success?: (result: { Data: Innosoft_WebCRM_Statistics_Model_UserAdminViewModel }) => void, failure?: (result: any) => void) {
        utility.httpService.get(Config.baseUrl + 'UserAdmin/GetAllUSersAndStatisticsCurrentUser', {showInternal: showInternal}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, true);
    }
    Save(id: string, value: any[], success?: (result: { Data: Innosoft_InnoBI_Controllers_StatisticUiCategories[] }) => void, failure?: (result: any) => void) {
        utility.httpService.postJson(Config.baseUrl + 'UserAdmin/Save', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { id: id }, true);
    }
    ResetSettings(id: string, success?: (result: { Data: Innosoft_InnoBI_Controllers_StatisticUiCategories[] }) => void, failure?: (result: any) => void) {
        utility.httpService.postJson(Config.baseUrl + 'UserAdmin/ResetSettings', null, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { id: id }, true);
    }
}
export class Innosoft_InnoBI_Controllers_ApiBuilderController extends utility.ApiControllerBase {
    Get(success?: (result: Innosoft_InnoBI_Models_SqlServiceDefinition[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/Get', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetAllServices(success?: (result: Innosoft_InnoBI_Repositories_Service[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/GetAllServices', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetAllServicesOfType(dataSourceType: any, success?: (result: Innosoft_InnoBI_Repositories_Service[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/GetAllServicesOfType', { dataSourceType: dataSourceType }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetAllServiceTypes(success?: (result: Innosoft_InnoBI_Repositories_Types[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/GetAllServiceTypes', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetServiceConfig(id: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/GetServiceConfig', { id: id }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetAvailableAssemblyServices(success?: (result: Innosoft_InnoBI_IWebservice[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/GetAvailableAssemblyServices', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    Save(id: string, value: any, success?: (result: void) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/ApiBuilder/Dummy/Save', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { id: id });
    }
    ExecuteSql(value: any, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/ApiBuilder/Dummy/ExecuteSql', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    ExecuteHierarchicalSql(value: any, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/ApiBuilder/Dummy/ExecuteHierarchicalSql', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    CreateNewOrEditService(service: Innosoft_InnoBI_Repositories_Service, success?: (result: Innosoft_InnoBI_Repositories_Service) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/ApiBuilder/Dummy/CreateNewOrEditService', service, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    DeleteService(id: string, success?: (result: void) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/ApiBuilder/Dummy/DeleteService', { id: id }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    CopyService(value: any, success?: (result: Innosoft_InnoBI_Repositories_Service) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/ApiBuilder/Dummy/CopyService', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
}
export class Innosoft_InnoBI_Controllers_StatisticUiController extends utility.ApiControllerBase {
    ExportStatistic(Ids: string[], success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/ExportStatistic', { Ids: Ids }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    ImportStatistics(statisticExport: Innosoft_WebCRM_Statistics_Model_StatisticExport, success?: (result: void) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/ImportStatistics', statisticExport, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    CheckStatistics(statisticExport: Innosoft_WebCRM_Statistics_Model_StatisticExport, success?: (result: Innosoft_WebCRM_Statistics_Model_StatisticImportValidationResult) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/CheckStatistics', statisticExport, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    GetAllStatisticsUngrouped(success?: (result: Innosoft_InnoBI_Controllers_StatisticUi[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/GetAllStatisticsUngrouped', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetAllStatisticCategories(success?: (result: Innosoft_InnoBI_Controllers_StatisticUiCategories[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/GetAllStatisticCategories', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetStatisticConfig(id: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/GetStatisticConfig', { id: id }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetStatisticTranslated(id: string, isEmbedded: any, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/GetStatisticTranslated', { id: id, isEmbedded: isEmbedded }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    Save(id: string, value: any, success?: (result: void) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/Save', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { id: id });
    }
    CreateNewOrEditStatistic(statistic: Innosoft_InnoBI_Controllers_StatisticUi, success?: (result: Innosoft_InnoBI_Controllers_StatisticUi) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/CreateNewOrEditStatistic', statistic, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    CopyStatistic(value: any, success?: (result: Innosoft_InnoBI_Controllers_StatisticUi) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/CopyStatistic', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    OverrideInternalStatistic(value: any, success?: (result: Innosoft_InnoBI_Controllers_StatisticUi) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/StatisticUi/Dummy/OverrideInternalStatistic', value, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    DeleteStatistic(id: string, success?: (result: void) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticUi/Dummy/DeleteStatistic', { id: id }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
}
export class Innosoft_InnoBI_Controllers_StatisticsExporterController extends utility.ApiControllerBase {
    GetQuery(success?: (result: string) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/StatisticsExporter/Dummy/GetQuery', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
}
export class Innosoft_WebCRM_Statistics_Controllers_SettingsController extends utility.ApiControllerBase {
    GetSettings(success?: (result: any[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/Settings/Dummy/GetSettings', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
}
export class Innosoft_InnoBI_Controllers_FlexcelExportController extends utility.ApiControllerBase {
    GenerateExcelFile(serviceId: string, _templatename: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/FlexcelExport/Dummy/GenerateExcelFile', { serviceId: serviceId, _templatename: _templatename }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GetExportFile(serviceId: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/FlexcelExport/Dummy/GetExportFile', { serviceId: serviceId }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
}
export class Innosoft_WebCRM_Statistics_Controllers_CategoryController extends utility.ApiControllerBase {
    GetCategories(success?: (result: Innosoft_InnoBI_Repositories_Category[]) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/Category/Dummy/GetCategories', {}, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    SaveCategories(categories: Innosoft_InnoBI_Repositories_Category[], success?: (result: Innosoft_InnoBI_Repositories_Category[]) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/Category/Dummy/SaveCategories', categories, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
}
export class Innosoft_InnoBI_Controllers_DynamicApiController extends utility.ApiControllerBase {
    GetDataByServiceName(serviceId: string, success?: (result: any) => void, failure?: (result: any) => void) {
        throw { name: 'NotImplementedError', message: 'Not implemented' };
    }
    GetDataBatched(b: any, success?: (result: any[]) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/DynamicApi/Dummy/GetDataBatched', b, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, {});
    }
    TypeToString(o: any, success?: (result: string) => void, failure?: (result: any) => void) {
        throw { name: 'NotImplementedError', message: 'Not implemented' };
    }
    GetData(serviceId: string, success?: (result: any) => void, failure?: (result: any) => void) {
        throw { name: 'NotImplementedError', message: 'Not implemented' };
    }
    GetServiceMetadataById(serviceId: string, success?: (result: Innosoft_WebCRM_Statistics_Services_ColumnMetadata[]) => void, failure?: (result: any) => void) {
        throw { name: 'NotImplementedError', message: 'Not implemented' };
    }
    GetExportFile(serviceId: string, __templateName: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/DynamicApi/Dummy/GetExportFile', { serviceId: serviceId, __templateName: __templateName }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
    GenerateFile(serviceId: string, __templateName: string, parameters: any[], success?: (result: string) => void, failure?: (result: any) => void) {
        utility.httpService.postJson('api/DynamicApi/Dummy/GenerateFile', parameters, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) }, { serviceId: serviceId, __templateName: __templateName });
    }
    GetFileByName(filename: string, success?: (result: any) => void, failure?: (result: any) => void) {
        utility.httpService.get('api/DynamicApi/Dummy/GetFileByName', { filename: filename }, (result) => { this.invokeCallback(success, result) }, (error) => { this.invokeCallback(failure, error) });
    }
}
export interface Innosoft_WebCRM_Statistics_Services_ColumnMetadata {
    ColumnName?: string;
    ColumnType?: any;
}
export interface Innosoft_InnoBI_Repositories_Category {
    Id?: any;
    Name?: string;
}
export interface Innosoft_InnoBI_Controllers_StatisticUi {
    Id?: string;
    Name?: string;
    CategoryId?: any;
    CategoryName?: string;
    UserRecht?: any;
    RollenRecht?: any;
    Rolle?: string;
    IsInternal?: any;
    Overrides?: string;
}
export interface Innosoft_WebCRM_Statistics_Model_StatisticImportValidationResult {
    AvailableStatistics?: any[];
    AvailableDatasources?: any[];
}
export interface Innosoft_WebCRM_Statistics_Model_StatisticExport {
    Statistics?: Innosoft_WebCRM_Statistics_Model_Statistic[];
    DataSources?: Innosoft_WebCRM_Statistics_Model_DataSource[];
}
export interface Innosoft_WebCRM_Statistics_Model_DataSource {
    ID?: string;
    SERVICE_NAME?: string;
    SERVICE_CONFIGURATION?: string;
    SERVICE_TYPE?: any;
    DELETED?: any;
    IS_INTERNAL?: any;
}
export interface Innosoft_WebCRM_Statistics_Model_Statistic {
    ID?: string;
    NAME?: string;
    STATISTIC_CONFIGURATION?: string;
    STATISTIC_CONTROLLER?: string;
    CATEGORY_ID?: any;
    DELETED?: any;
    DESCRIPTION?: string;
    IS_INTERNAL?: any;
    OVERRIDDEN_BY?: string;
}
export interface Innosoft_InnoBI_IWebservice {
    ServiceId?: string;
    ServiceName?: string;
    Description?: string;
    Parameter?: Innosoft_InnoBI_ServiceParameter[];
}
export interface Innosoft_InnoBI_ServiceParameter {
    ParameterName?: string;
    Description?: string;
    IsMandatory?: any;
}
export interface Innosoft_InnoBI_Repositories_Types {
    Id?: any;
    Name?: string;
}
export interface Innosoft_InnoBI_Repositories_Service {
    Id?: string;
    Type?: Innosoft_InnoBI_Repositories_ServiceType;
    TypeName?: string;
    ServiceName?: string;
    ServiceConfiguration?: string;
    IsInternal?: any;
}
export enum Innosoft_InnoBI_Repositories_ServiceType {
    Sql = 0, HierarchicalSql = 1, CSharpAssembly = 2
}
export interface Innosoft_InnoBI_Models_SqlServiceDefinition {
    GetQuery?: string;
    Id?: string;
    ServiceName?: string;
    ServiceType?: Innosoft_InnoBI_Models_ServiceTypes;
    Parameters?: Innosoft_InnoBI_Models_Parameter[];
    TranslateValues?: any;
}
export interface Innosoft_InnoBI_Models_Parameter {
    Name?: string;
    Type?: Innosoft_InnoBI_Models_ParameterDataTypes;
    IsArray?: any;
}
export enum Innosoft_InnoBI_Models_ParameterDataTypes {
    Number = 0, String = 1, Date = 2
}
export enum Innosoft_InnoBI_Models_ServiceTypes {
    Sql = 0, Code = 1, Assembly = 2
}
export interface Innosoft_WebCRM_Statistics_Model_UserAdminViewModel {
    Users?: Innosoft_WebCRM_Statistics_Model_User[];
    StatisticsOfCurrentUser?: Innosoft_InnoBI_Controllers_StatisticUiCategories[];
    UserName?: string;

}
export interface Innosoft_WebCRM_Statistics_Model_User {
    Login?: string;
    IsRole?: any;
    Name?: string;
    Vorname?: string;
    DisplayName?: string;

}
export interface Innosoft_InnoBI_Controllers_StatisticUiCategories {
    Id?: any;
    Name?: string;
    Statistics?: Innosoft_InnoBI_Controllers_StatisticUi[];
}
export interface Innosoft_InnoBI_Controllers_StatisticTranslationsController_TranslationKeyValue {
    Key?: string;
    LanguageId?: any;
    Language?: string;
    Translation?: string;
    BaseOrCustom?: string;
}
export interface Innosoft_InnoBI_Controllers_GetTranslationsRequest {
    BaseOrCustom?: string;
    Key?: string;
    Languages?: any[];
}
